<ng-container [formGroup]="formGroup" *ngIf="cirfUdfs?.length">
  <div class="padding-top-10" [formArrayName]="cirfFormArrayName">
    <ng-container *ngFor="let udf of cirfUdfs; let i=index">
      <mat-form-field class="padding-right-10 width-100" [formGroupName]="i"
                      [dp-field-visibility]="cirfUdfFieldKey+i" [isUdf]="true" >
        <mat-label>{{udf.fieldLabel}}</mat-label>
        <input maxlength="50" matInput formControlName="fieldValue" *ngIf="cirfUdfs && cirfUdfs.length">
        <mat-error>This field is required</mat-error>
      </mat-form-field>
    </ng-container>
  </div>
</ng-container>